import { render } from "./defaultStyle.vue?vue&type=template&id=99447628"
import script from "./defaultStyle.vue?vue&type=script&lang=js"
export * from "./defaultStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__